import type { FaireProductEntity } from "../../entity_types/product";

export const p_63728gjcy7: FaireProductEntity = {
  token: "p_63728gjcy7",
  type: "product",
  name: "LM-SK-1000 BUBBLE SKIRT - ROYAL",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/e25b63fb1c1207b60c3e31372630664dbb37bf2688dbcdb6da108cc775cbed85.jpeg",
  galleryImageUrls: [],
  priceDollars: 17.5,
  description: "This playful bubble skirt from Girlie Girl Originals offers a lively silhouette that adds movement and charm to looks alike. Designed with attention to styling and wearability, it complements a range of tops and accessories and reflects the brand’s bold, fun aesthetic.",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:30.206Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
